export default "__VITE_ASSET__BtMsaHC4__"